<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-05 10:03:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-09-25 14:50:30
 * @FilePath: \mrc-base-server-view\src\views\mrc_system_admin\add\index.vue
-->
<template>
  <div>
    <base-info @success='success'
               :disabled='false'
               :loading='loading'
               :successText="$t('label_submit')"
               @cancel='cancel'></base-info>
  </div>
</template>

<script>
import { mrc_admin_add } from '@/service/api/mrc_system_admin'
import baseInfo from '../modules/baseInfo'
export default {
  components: { baseInfo },
  props: {},
  data () {
    return {
      params: {},
      loading: false
    };
  },
  computed: {},
  created () { },
  watch: {},
  mounted () { },

  methods: {
    cancel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_cancellation_of_the_edit') })
        .then(() => {
          this.$router.go(-1)
        }).catch(() => { })
    },
    async success (obj) {
      this.loading = true
      const res = await mrc_admin_add({ ...obj, org_level_uuid: this.$store.state.userData.org_level_uuid, role_uuid: '003', login_url: this.$store.state.loginUrl })

      if (res.code == 200) {
        this.$Message({ text: this.$t('message_The_operation_was_successful') })
        this.$router.go(-1)
      }

      this.loading = false
    }
  },
};
</script>

<style scoped>
</style>
